import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';

export interface EnrichmentAllowance {
  cap: number;
  used: number;
  remaining: number;
}

export function useEnrichmentAllowance(orgId: number | undefined) {
  return useQuery<EnrichmentAllowance>({
    queryKey: ['orgs', orgId, 'enrichment-allowance'],
    queryFn: () =>
      apiGet<EnrichmentAllowance>(
        `/api/orgs/${orgId}/crm-events/bulk-action/enrichment-allowance/`
      ),
    enabled: !!orgId,
    staleTime: 60_000,
    retry: 1,
  });
}
